import {
  type Advisor,
  type FetchClient,
  useFetchOneClient,
} from "@verde/entities";
import { RaioXRural, useAuthContext } from "@verde/modules";
import { useSaasBlockAlert } from "components/saas-block-alert";
import { CreditProfile } from "modules/credit-profile";
import type { CreditProfilePanelResource } from "modules/credit-profile/components/panel/types";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { create } from "zustand";

interface UseRaioXRuralSearch {
  client?: FetchClient;
  setClient: (client?: FetchClient) => void;
}
export const useRaioXRuralSearch = create<UseRaioXRuralSearch>((set) => {
  return {
    client: undefined,
    setClient: (client?: FetchClient) => {
      set(() => ({ client }));
    },
  };
});

export default function RaioXRuralSearch() {
  const navigate = useNavigate();
  const params = useParams();
  const saasBlockAlert = useSaasBlockAlert();
  const { user } = useAuthContext<Advisor>();

  const client_id = params?.client_id ? Number(params?.client_id) : undefined;
  const credit_usage_id = params?.credit_usage_id
    ? Number(params.credit_usage_id)
    : undefined;

  const fetched_client = useFetchOneClient(client_id);

  const { client, setClient } = useRaioXRuralSearch();

  const [resource, setResource] = useState<
    CreditProfilePanelResource | undefined
  >(undefined);

  useEffect(() => {
    if (fetched_client.data) {
      setClient(fetched_client.data);
    }
  }, [setClient, fetched_client.data]);

  useEffect(() => {
    if (!params?.client_id && client?.id) {
      setClient(undefined);
      setResource(undefined);
    }
  }, [params, setClient, client]);

  return (
    <div className="grid gap-4">
      <CreditProfile.Panel
        client={client}
        credit_usage_id={credit_usage_id}
        loading={fetched_client.isLoading}
        mode={user?.kind === "FUND_MANAGER" ? "fund-manager" : "standalone"}
        onSearchClient={(client) => {
          setClient(client);
          navigate(`/raio-x-rural/${client?.id}`);
        }}
        onResource={setResource}
        options={{
          has_history: true,
        }}
      />

      {user?.kind !== "FUND_MANAGER" && (
        <>
          <RaioXRural.ProspectQualification
            client={client}
            onClick={
              user?.kind === "SAAS_USER" ? saasBlockAlert.toggle : undefined
            }
          />

          {resource?.available && client?.kind === "RURAL_PRODUCER" && (
            <CreditProfile.Tab client={client} creditUsage={resource.data} />
          )}
        </>
      )}
    </div>
  );
}
